import {NavigateAway} from '@staff-app/actions/experience.actions';
import {
  ExperienceActions,
  ExperienceActionTypes
} from '@staff-app/actions/experience.actions';
import {ExperienceDTO} from '@staff-app/models/experienceDTO';
import {CommonActions, CommonActionTypes} from '@store/actions/common.actions';

export interface State {
  experiences: ExperienceDTO;
}

export const initialState: State = {
  experiences: null
};

export function reducer(
  state = initialState,
  action: ExperienceActions | CommonActions
): State {
  switch (action.type) {
    case ExperienceActionTypes.GetExperiencesSuccessful: {
      return {
        ...state,
        experiences: action.payload
      };
    }
    case ExperienceActionTypes.SaveExperiencesSuccessful:
    case ExperienceActionTypes.NavigateAway:
    case CommonActionTypes.NavigateToSubmitPage: {
      return initialState;
      // remove store to prevent data load from cache
    }
    default: {
      return state;
    }
  }
}

export const getProductSkills = (state: State) => {
  return state.experiences && state.experiences.productSkills;
};

export const getInstructorSkills = (state: State) => {
  return state.experiences && state.experiences.instructorSkills;
};

export const getManagementSkills = (state: State) => {
  return state.experiences && state.experiences.managementSkills;
};

export const getExperienceData = (state: State) => {
  return state.experiences && state.experiences;
};
